import { type AppDirection } from "@core/shared/types";
import { isRTL } from "@core/shared/utils";

export function useDirection(): AppDirection {
  return isRTL() ? "rtl" : "ltr";
}

export function useIsRTL() {
  return isRTL();
}
